import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { i18n } from "@lingui/core";
import React, { useEffect } from 'react';
import { useLingui } from '@lingui/react';
import './blog.scss';
import SEO from '../components/shared/seo';
import SingleBlog from '../components/blog/single-blog/single-blog';
import PrevNextPagination from '../components/shared/navigation/prev-next-pagination/prev-next-pagination';
import RelatedItems from '../components/shared/ui-elements/related-items/related-items';
import Card from '../components/shared/ui-elements/card/card';
import shuffleArray from '../utils/suffle-array';
export default (function (_ref) {
  var _blog$title, _blog$title2, _blog$slug, _blog$category, _blog$category$title, _blog$category2, _blog$category2$title, _blog$description, _blog$description2, _blog$thumbnail, _blog$thumbnail$asset;

  var data = _ref.data,
      location = _ref.location,
      props = _objectWithoutPropertiesLoose(_ref, ["data", "location"]);

  console.log({
    data: data,
    props: props
  });
  var blog = data.sanityBlog; // selected blog

  var blogs = data.allSanityBlog.edges; // all blog

  var _useLingui = useLingui(),
      i18n = _useLingui.i18n;

  var locale = i18n.locale; // For legible code

  var newBlog = {
    title: locale === 'en' ? (_blog$title = blog.title) === null || _blog$title === void 0 ? void 0 : _blog$title.en : (_blog$title2 = blog.title) === null || _blog$title2 === void 0 ? void 0 : _blog$title2.ja,
    slug: (_blog$slug = blog.slug) === null || _blog$slug === void 0 ? void 0 : _blog$slug.current,
    publishedAt: locale === 'en' ? new Date(blog.publishedAt).toLocaleDateString('en-US') : new Date(blog.publishedAt).toLocaleDateString('ja-JP'),
    category: locale === 'en' ? (_blog$category = blog.category) === null || _blog$category === void 0 ? void 0 : (_blog$category$title = _blog$category.title) === null || _blog$category$title === void 0 ? void 0 : _blog$category$title.en : (_blog$category2 = blog.category) === null || _blog$category2 === void 0 ? void 0 : (_blog$category2$title = _blog$category2.title) === null || _blog$category2$title === void 0 ? void 0 : _blog$category2$title.ja,
    description: locale === 'en' ? (_blog$description = blog.description) === null || _blog$description === void 0 ? void 0 : _blog$description._rawEn : (_blog$description2 = blog.description) === null || _blog$description2 === void 0 ? void 0 : _blog$description2._rawJa,
    thumbnail: (_blog$thumbnail = blog.thumbnail) === null || _blog$thumbnail === void 0 ? void 0 : (_blog$thumbnail$asset = _blog$thumbnail.asset) === null || _blog$thumbnail$asset === void 0 ? void 0 : _blog$thumbnail$asset.fluid,
    subImages: blog.subImages,
    likes: blog.likes,
    id: blog._id
  }; // For legible code

  var newBlogs = blogs.map(function (_ref2) {
    var _blog$title3, _blog$title4, _blog$slug2, _blog$thumbnail2, _blog$thumbnail2$asse, _blog$category3, _blog$category3$title, _blog$category4, _blog$category4$title;

    var blog = _ref2.node;
    return {
      title: locale === 'en' ? (_blog$title3 = blog.title) === null || _blog$title3 === void 0 ? void 0 : _blog$title3.en : (_blog$title4 = blog.title) === null || _blog$title4 === void 0 ? void 0 : _blog$title4.ja,
      slug: (_blog$slug2 = blog.slug) === null || _blog$slug2 === void 0 ? void 0 : _blog$slug2.current,
      date: locale === 'en' ? new Date(blog.publishedAt).toLocaleDateString('en-US') : new Date(blog.publishedAt).toLocaleDateString('ja-JP'),
      thumbnail: (_blog$thumbnail2 = blog.thumbnail) === null || _blog$thumbnail2 === void 0 ? void 0 : (_blog$thumbnail2$asse = _blog$thumbnail2.asset) === null || _blog$thumbnail2$asse === void 0 ? void 0 : _blog$thumbnail2$asse.fluid,
      category: locale === 'en' ? (_blog$category3 = blog.category) === null || _blog$category3 === void 0 ? void 0 : (_blog$category3$title = _blog$category3.title) === null || _blog$category3$title === void 0 ? void 0 : _blog$category3$title.en : (_blog$category4 = blog.category) === null || _blog$category4 === void 0 ? void 0 : (_blog$category4$title = _blog$category4.title) === null || _blog$category4$title === void 0 ? void 0 : _blog$category4$title.ja,
      likes: blog.likes,
      id: blog._id
    };
  }); // To get a current "prefix" of url

  var pathname = location.pathname,
      href = location.href;
  var temp = pathname.split('/');
  temp.pop();
  var prefix = temp.join('/'); // ex: "/ja/blog"
  // Filtered by "the same category" "excluding current blog"

  var filteredBlogs = newBlogs.filter(function (nb) {
    return nb.category === newBlog.category && nb.slug !== newBlog.slug;
  }); // Shuffle related items

  useEffect(function () {
    shuffleArray(filteredBlogs);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SEO, {
    title: newBlog.title,
    lang: locale,
    url: href
  }), /*#__PURE__*/React.createElement("div", {
    className: "blog-page"
  }, /*#__PURE__*/React.createElement(SingleBlog, {
    blog: newBlog,
    url: href
  }), /*#__PURE__*/React.createElement(PrevNextPagination, {
    items: newBlogs,
    curSlug: newBlog.slug,
    prefix: prefix
  }), /*#__PURE__*/React.createElement(RelatedItems, {
    title: i18n._(
    /*i18n*/
    i18n._("related articles"))
  }, filteredBlogs.length > 0 ? filteredBlogs.slice(0, 3).map(function (blog, i) {
    return /*#__PURE__*/React.createElement(Card, {
      key: i,
      item: blog,
      place: "blog-page"
    });
  }) : /*#__PURE__*/React.createElement("p", null, i18n._(
  /*i18n*/
  i18n._("No item found.."))))));
});
var query = "3744817500";